import { useCallback, useState } from 'react'
import * as React from 'react'
import { useParams } from 'react-router-dom'
import { ModalDialog, ModalDialogTitle } from 'uiComponents/popups/modal'
import styled from 'styled-typed'
import { ActionButtonA } from 'uiComponents/buttons'
import { BaseRouteParams } from '../../../../hocs'
import { Trans, useTranslation } from 'translations'

const ModalDialogBody = styled.div`
    padding-top: 1.2em;
    font-weight: lighter;
    width: 400px;
`

const ModalDialogContent = styled.div`
    line-height: 1.6em;
`

const Buttons = styled.div`
    display: flex;
    justify-content: flex-end;
    padding-top: 2em;
`

interface DialogProps {
    onCancel: () => void
}

const RequestMapDialog = (props: DialogProps) => {
    const { t } = useTranslation()
    const { accountSlug } = useParams<BaseRouteParams>()
    const [requestSent, setRequestSent] = useState<boolean>(false)
    const EMAIL = 'customersuccess@convious.com'
    const BCC = 'ronald@convious.com'
    const SUBJECT = 'Custom map - contact request'
    const BODY = `Please contact me regarding creating a custom map. (${accountSlug})`

    const requestMap = useCallback(() => {
        setRequestSent(true)
    }, [])

    return (
        <ModalDialog onDismiss={props.onCancel} interactive fromTop="20%">
            <ModalDialogBody>
                <ModalDialogTitle>{t('venue.parkMap.customMapRequest.title')}</ModalDialogTitle>
                {requestSent ? (
                    <ModalDialogContent>
                        <Trans i18nKey="venue.parkMap.customMapRequest.sentText" components={{ br: <br /> }} />
                        <Buttons>
                            <ActionButtonA secondary onClick={props.onCancel}>
                                {t('common.close')}
                            </ActionButtonA>
                        </Buttons>
                    </ModalDialogContent>
                ) : (
                    <ModalDialogContent>
                        <Trans i18nKey="venue.parkMap.customMapRequest.text" components={{ br: <br /> }} />
                        <Buttons>
                            <ActionButtonA secondary style={{ marginRight: '1em' }} onClick={props.onCancel}>
                                {t('common.cancel')}
                            </ActionButtonA>
                            <ActionButtonA
                                href={`mailto:${EMAIL}?bcc=${BCC}&subject=${SUBJECT}&body=${BODY}`}
                                onClick={requestMap}
                            >
                                {t('venue.parkMap.customMapRequest.sendRequest')}
                            </ActionButtonA>
                        </Buttons>
                    </ModalDialogContent>
                )}
            </ModalDialogBody>
        </ModalDialog>
    )
}

export default RequestMapDialog
